<template>
  <ul>
    <comment-item v-on:spot="spot(arguments)"
      v-for="(item) in commentList"
      :key="item.pid"
      :item="item"
      :level="level">
      <template #content="{ row, childLevel }">
        <template v-if="row.subComments && row.subComments.length > 0">
          <comment-list :comments="row.subComments" :level="childLevel"></comment-list>
        </template>
      </template>
    </comment-item>
  </ul>
</template>

<script>
import CommentItem from '../commentItem/commentItem'
import bus from '../../utils/bus.js'
import service from "@/api/service/service";
import { storageData } from "@/assets/js/storage";
import moment from "moment";
export default {
  name: 'CommentList',
  props: {
    thread:{
      type:Object
    },
    thread:{
      type:Object
    },
    //  评论内容列表
    comments: {
      type: Array,
      default: () => ({})
    },
    //  评论的层级, 控制样式左边的padding值
    level: {
      type: Number,
      default: 0
    }
  },
  components: {
    CommentItem
  },
  data () {
    return {
      list: [],
      areaUserinfo:{},
    }
  },
  watch:{
    username(newVal,oldVal ) {
      console.log('newVal=========',newVal)
      console.log('oldVal=========',oldVal)
      this.areaUserinfo = storageData.getUserInfo()
    }
  },
  created () {
    bus.$on('toggle-reply', ({ pid }) => {
      this.list = this.comments.map(item => ({ ...item, showReply: item.pid === pid }))
    })
  },
  computed: {
    username(){
      return this.areaUserinfo.username
    },
    commentList () {
      return this.list && this.list.length > 0 ? this.list : this.comments
    }
  },
  mounted(){
      // console.log(this.$route.params.tid)
      console.log('222')
      window.onstorage = function() {
        this.areaUserinfo = localStorage.getItem('loginUserInfo')
            console.log('监听storage：', localStorage.getItem('loginUserInfo'));
        }
      this.areaUserinfo=storageData.getUserInfo()
  },
  methods:{
    spot:function(params){
      this.areaUserinfo=storageData.getUserInfo()
      // console.log(params)
      // console.log(params[0])
      // console.log(params[1].pid)
      // console.log(this.comments)
      let pid = params[1].pid //要评论的pid
      let message = params[0] //传过来的评的内容
      let tid= this.$route.params.tid
      service.post(`${this.commonIp}/v1/threads/reply`,{
              tid:tid,
              message:message,
              pid:pid
      }).then((res)=>{
        // console.log(res)
        //回复的哪个item就追加到哪个item里面 应该把回的消息追加到subComents里
        //是回的子评论还是回的评论 无论是回子评论还是回评论都是向subComments里push
        if(!pid){ //为空时不是回复评论 直接返回
          return
        }else{
          let avatar=storageData.getUserInfo().avatar
          let author = storageData.getUserInfo().username
          this.comments.forEach(ele => {
            //根据pid找到回的那项  回评论
            let comment = ele
            if(ele._id == pid){
              comment.subComments = comment.subComments || []
              let quote=null
              comment.subComments.push({
                message:res.data.data.message.replace('onclick="intoPerson(this,event)"','style="color:#406599"'),
                pid:res.data.data.pid,
                _id:res.data.data.pid,
                supports:0,
                rpid: res.data.data.pid,
                firstRpid: res.data.data.firstRpid,
                author:author,
                avatar:avatar,
                subComments:[],
                quote: quote,
                dateline:moment(new Date().getTime()).unix()
              })
            }
          });
        }
        //评论完得把回复框再给隐藏
        this.list = this.comments.map(item => ({ ...item, showReply:false}))
        //追加的有问题，不要把每一个的subComments里都加上评的内容，而是只追加回的那条的subComments里
        // console.log(this.comments)
        // console.log(this.list)
      })
    }
  },
  beforeDestroy () {
    bus.$off('toggle-reply')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/commentList/commentList.vue